/**
 * @file: ProductDetailInfo.ts
 * @copyright: (c) 2019-2023 sichuan zhichetech co., ltd.
 */

import { ProductDetailContentType } from '@euler/model/enum';

export type ProductConstructionProcedureApplyType = 'merge' | 'replace';

export type ProductDetailInfo = {
  contents: ProductDetailImageListContent;
  constructionProcedures?: ProductConstructionProcedure[];
  constructionProceduresRequired?: boolean;
  constructionProceduresApplyType?: ProductConstructionProcedureApplyType;
};

export enum ProductAnyImageType {
  Image = 'image',
  Video = 'video',
}

export type ProductAnyImage = {
  id: string;
  type: ProductAnyImageType;
  title?: string;
  description?: string;
  url: string;
  coverUrl?: string;
};

export type ProductDetailImageListItem = ProductAnyImage;

export type ProductDetailImageListContent = {
  type: ProductDetailContentType.ImageList;
  images: ProductDetailImageListItem[];
};

export type ProductDetailHtmlTemplateContent = {
  type: ProductDetailContentType.HtmlTemplate;
  templateId: string;
  data: string;
};

export type ProductDetailContent =
  | ProductDetailImageListContent
  | ProductDetailHtmlTemplateContent;

export type ProductConstructionProcedureStdImage = ProductAnyImage;

export type ProductConstructionProcedure = {
  id: string;
  name: string;
  requiresPhoto?: boolean;
  removable?: boolean;
  stdImages?: ProductConstructionProcedureStdImage[];
};
